import { request } from '@sweetspot/shared/data-access/api-platform'
import { getApiPlatformBaseUrl } from '@sweetspot/shared/util/functions'

/**
 * Creates new membership beloning to passed club ID
 *
 * @param {string|number} id
 * @param {Object} payload
 * @returns {Promise}
 */
export const _addMembership = (clubId, payload) => {
  const URL = `${getApiPlatformBaseUrl()}/clubs/${clubId}/memberships/new`
  return request(URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
  })
}

/**
 * Updates membership
 *
 * @param {string|number} membershipId
 * @param {Object} payload
 * @returns {Promise}
 */
export const _updateMembership = (membershipId, payload) => {
  const URL = `${getApiPlatformBaseUrl()}/crm/memberships/${membershipId}`
  return request(URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
  })
}

/**
 * Deletes membership
 *
 * @param {string|number} membershipId
 * @returns {Promise}
 */
export const _deleteDraftMembership = (membershipId) => {
  const URL = `${getApiPlatformBaseUrl()}/crm/memberships/${membershipId}`
  return request(URL, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

/**
 * Publishes membership
 *
 * @param {string|numver} membershipId
 */
export const _publishMembership = (membershipId) => {
  const URL = `${getApiPlatformBaseUrl()}/crm/memberships/${membershipId}/publish`
  return request(URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {},
  })
}

/**
 * Adds promotion to membership
 *
 * @param {string|number} membershipId
 * @param {Object} payload
 * @returns {Promise}
 */
export const _addPromotion = (membershipId, payload) => {
  const URL = `${getApiPlatformBaseUrl()}/crm/memberships/${membershipId}/promotion/new`
  return request(URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
  })
}

/**
 * Get's single membership by ID
 *
 * @param {string|number} membershipId
 * @returns {Promise}
 */
export const _getMembershipById = (membershipId) => {
  const URL = `${getApiPlatformBaseUrl()}/memberships/${membershipId}`

  return request(URL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

/**
 * Adds fee to membership
 *
 * @param {string|number} membershipId
 * @param {Object} payload
 * @returns {Promise}
 */
export const _addFeeToMembership = (membershipId, payload) => {
  const URL = `${getApiPlatformBaseUrl()}/crm/memberships/${membershipId}/fees/new`
  return request(URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
  })
}

/**
 * Updates a fee entity
 *
 * @param {string|number} feeId
 * @param {Object} payload
 * @returns {Promise}
 */
export const _updateFee = (feeId, payload) => {
  const URL = `${getApiPlatformBaseUrl()}/crm/fees/${feeId}`
  return request(URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
  })
}

/**
 * Deletes a fee
 *
 * @param {string|number} feeId
 * @returns {Promise}
 */
export const _deleteFee = (feeId) => {
  const URL = `${getApiPlatformBaseUrl()}/crm/fees/${feeId}`
  return request(URL, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

/**
 * Delete membership
 *
 * @param {string|number} membershipId
 * @returns {Promise}
 */
export const _deleteMembership = (membershipId) => {
  const URL = `${getApiPlatformBaseUrl()}/crm/memberships/${membershipId}`
  return request(URL, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export function _addPlayerToMembership(membershipId, payload) {
  const URL = `${getApiPlatformBaseUrl()}/crm/memberships/${membershipId}/card/new`

  return request(URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
  })
}

export function _markMembershipAsPaid(id) {
  const URL = `${getApiPlatformBaseUrl()}/crm/membership-cards/${id}/mark-as-paid`

  return request(URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {},
  })
}

export function _unmarkMembershipAsPaid(id) {
  const URL = `${getApiPlatformBaseUrl()}/crm/membership-cards/${id}/cancel`

  return request(URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {},
  })
}

export function _removeMembershipCard(id) {
  const URL = `${getApiPlatformBaseUrl()}/crm/membership-cards/${id}`

  return request(URL, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export function _sendPaymentLink(orderId) {
  const URL = `${getApiPlatformBaseUrl()}/bookings/memberships/${orderId}/payment/send`

  return request(URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {},
  })
}

export function _lockUnlockMembership(uuid) {
  const URL = `${getApiPlatformBaseUrl()}/membership-cards/${uuid}/lock`

  return request(URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    rawResponse: true,
    body: {},
  })
}

/**
 * Locks or unlocks multiple membership cards.
 *
 * @param {Array} membershipCards - The array of membership cards to be locked or unlocked.
 * @param {string} actionName - The action to be performed on the membership cards (e.g., "lock", "unlock").
 * @returns {Promise} A promise that resolves to the response of the API request.
 */
export function _lockUnlockMemberships(membershipCards, actionName = 'lock') {
  const URL = `${getApiPlatformBaseUrl()}/membership-cards/lock-bulk`
  return request(URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {
      action: actionName,
      membership_cards: membershipCards,
    },
  })
}
